import { useState } from "react";
import { Link } from "react-router-dom";
import { useConsent } from "../../contexts/ConsentContext";
import PreferenceCentre from "./PreferenceCentre";
import "./CookieBanner.css";

const CookieBanner = () => {
  const { hasDecided, acceptAll, rejectNonEssential } = useConsent();
  const [showPrefs, setShowPrefs] = useState(false);

  if (hasDecided && !showPrefs) return null;

  return (
    <>
      {!hasDecided && (
        <div className="cookie-banner" role="dialog" aria-label="Cookie preferences">
          <div className="cookie-banner-inner">
            <div className="cookie-banner-text">
              <strong>We use cookies</strong>
              <p>
                We use cookies to run this site, and — only with your permission —
                to understand how it's used and make it more relevant to you.
                See our <Link to="/privacy">Privacy Policy</Link> for details.
              </p>
            </div>
            <div className="cookie-banner-actions">
              <button
                type="button"
                className="cookie-btn cookie-btn-reject"
                onClick={() => rejectNonEssential("banner")}
              >
                Reject non-essential
              </button>
              <button
                type="button"
                className="cookie-btn cookie-btn-customise"
                onClick={() => setShowPrefs(true)}
              >
                Customise
              </button>
              <button
                type="button"
                className="cookie-btn cookie-btn-accept"
                onClick={() => acceptAll("banner")}
              >
                Accept all
              </button>
            </div>
          </div>
        </div>
      )}
      {showPrefs && <PreferenceCentre onClose={() => setShowPrefs(false)} />}
    </>
  );
};

export default CookieBanner;
